module.exports = __webpack_public_path__ + "static/media/Portrait-10192.15d67ac0.jpg";